import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import './styles.scss';


const BaseModal = ({ title, children, show, handleClose, cancelBtn }) => {
  if (!show) return null;
  return (
    <div className="backdrop">
      <div className='modalWrapper'>
        <div className="modal">
          <div id="closeModalButton" >
            <IconButton onClick={handleClose} disabled={cancelBtn}          >
              <CloseIcon color='warning' />
            </IconButton>
          </div>
          <h6 className='modaltitle'>{title}</h6>
          {children}
        </div>
      </div>
    </div>
  )
};

export default BaseModal;